import React, { useState } from 'react'
import { TabItem, TabsMenu } from './TabsMenu'
import { TabPanel } from './TabPanel'

interface TabKanbanProps {
  value?: number
  onChange?: (event: React.SyntheticEvent, newValue: number) => void
  tabs: TabItem[]
  defaultValue?: number
}

const TabKanban = ({
  value,
  onChange,
  tabs,
  defaultValue = 0
}: TabKanbanProps) => {
  const isControlled = value !== undefined && onChange !== undefined
  const [internalValue, setInternalValue] = useState(defaultValue)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (isControlled) {
      onChange?.(event, newValue)
    } else {
      setInternalValue(newValue)
    }
  }

  const currentValue = isControlled ? value : internalValue

  return (
    <>
      <TabsMenu value={currentValue} onChange={handleChange} tabs={tabs} />
      {tabs.map((tab, index) => (
        <TabPanel key={index} value={currentValue} index={index}>
          {tab.content}
        </TabPanel>
      ))}
    </>
  )
}

export default TabKanban
